import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  "aria-label": "community details",
  class: "community-details"
}
const _hoisted_2 = {
  key: 0,
  class: "community-details-title"
}
const _hoisted_3 = {
  key: 1,
  class: "community-details-text"
}
const _hoisted_4 = { class: "community-details-status" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "community-details-btngroups" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "form-check title-case-text" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["title"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "form-check title-case-text" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["title"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "input-label"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "input-label"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  class: "dropdown-item",
  key: "all"
}
const _hoisted_27 = { class: "form-check" }
const _hoisted_28 = ["value"]
const _hoisted_29 = ["for"]
const _hoisted_30 = ["value", "id", "onClick"]
const _hoisted_31 = ["for"]
const _hoisted_32 = {
  "aria-label": "cta buttons",
  class: "cta__btn"
}
const _hoisted_33 = {
  key: 0,
  class: "input-label"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["for"]
const _hoisted_36 = ["value", "id"]
const _hoisted_37 = ["for"]
const _hoisted_38 = {
  "aria-label": "cta buttons",
  class: "cta__btn"
}

import {
  CommunityQmiDetails,
  HeaderData,
  NeighborhoodPlanQmiCounts,
  NeighborhoodSoldDetails,
  QmiDays,
  Sibling,
  SidebarHomePlan,
  planDetails,
} from '@/types';
import ArrowDownIcon from '@/assets/icons/ArrowDown.vue';
import RangeSlider from './modal/RangeSlider.vue';
import {
  HomePlanSortOptions,
  QmiDaysFilter,
  SliderChange,
  OrderHomeTypeList,
  UrlFilterList,
  Settings,
} from '@/constant';
import { compareSortingValue } from '@/core/funcs';
import { isMobile, isTablet } from 'mobile-device-detect';
import { computed, onMounted, reactive, ref, toRefs, watch, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import emitter from '../mitt';
import { DivisionInfo, CommunityInfo } from '@/types';

// injector


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeaderCommunityDetails',
  props: {
    headerData: {},
    availableSites: {},
    availablePlans: {},
    qmiAndHomeplans: {},
    availableLots: {},
    selectedNeighborhoodIds: {},
    planPriceExsist: { type: Boolean },
    qmiDetails: {},
    soldPercentage: {},
    neighborhoodsPlanQmiCount: {},
    communityHomePlans: {},
    initialHomePlanCount: {},
    filterQmiCount: {},
    qmiFilter: { type: Boolean },
    qmiAppliedMobile: { type: Boolean },
    homeTypeCount: {},
    communityName: {},
    areaName: {},
    neighborhoodLotsCount: { type: Function },
    isComingSoon: { type: Function }
  },
  emits: [
  'filterPlanNameHomeType',
  'setSorting',
  'setPlanNameListId',
  'loadNeighborhood',
  'applyUrlQmi',
  'applyMobileFilters',
  'setPlanDetailsHometypeList',
  'applyMobilePriceFilter',
  'selectNeighborhood',
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const isSalesOrLandView = inject('setSelectionDropdown', ref(false));

const showPlanName = ref(false);
const showPriceRange = ref(false);
const showHomeType = ref(false);
const showDivision = ref(false);
const showCommunity = ref(false);
const showNeighborhood = ref(false);
const selectedDivision = ref({} as DivisionInfo);
const selectedCommunity = ref({} as CommunityInfo);
const selectedNeighborhood = ref({} as any);

const listHomeType = ref<string[]>([]);
const listPlanName = ref<string[]>([]);
const listPlanId = ref<string[]>([]);
// const initialListPlanName = ref<string[]>([])
// const initialHomeType = ref<string[]>([])

// const divisions = ref([] as any[]);
// const communities = ref([] as any[]);

const minRangeOnSlider = ref(0);
const maxRangeOnSlider = ref(0);
const showMinRangeOnSlider = ref(0);
const showMaxRangeOnSlider = ref(0);
const minValueAfterChangeOnSlider = ref(0);
const maxValueAfterChangeOnSlider = ref(0);

const initialMin = ref(Settings.MinValue);
const initialMax = ref(Settings.MaxValue);

const homeTypeList = reactive(new Set<string>());

// const showPlaneNameCount = ref(false)
// const showHomeTypeCount = ref(false)

const disableFilters = ref(false);
const initialPlanCount = ref(0);
const allPlansSelected = ref(false);

const planNameQmiList = ref<planDetails[]>([]);

const homePlanSortOptions = HomePlanSortOptions;
const qmiDaysFilter = QmiDaysFilter;

const hasMobile = ref<boolean>(!!(isMobile && !isTablet));

const urlMaxPrice = ref('');
const urlMinPrice = ref('');

const communitiesList = inject('communitiesList', ref([] as CommunityInfo[]));
const divisionList = inject('divisionList', ref([] as DivisionInfo[]));
// const neighborhoodList = inject("neighborhoodList", ref([]))

const props = __props;

const {
  headerData,
  availableSites,
  availablePlans,
  qmiAndHomeplans,
  availableLots,
  selectedNeighborhoodIds,
  planPriceExsist,
  qmiDetails,
  soldPercentage,
  neighborhoodsPlanQmiCount,
  communityHomePlans,
  initialHomePlanCount,
  filterQmiCount,
  qmiFilter,
  qmiAppliedMobile,
  homeTypeCount,
  neighborhoodLotsCount,
  isComingSoon,
  areaName,
  communityName,
} = toRefs(props);

const route = useRoute();
const router = useRouter();

const emit = __emit;

const neighborhoods = computed(() => {
  const siblings = headerData.value?.sibling ?? [];
  if(siblings.length) {
    return [...(siblings)].sort((a, b) =>
      a.neighborhood_name.localeCompare(b.neighborhood_name)
    );
  }
  return [];
});

// "N new home plans" counts the distinct Quick Move-in plans while that filter is
// active, and the community's home plans otherwise. Every writer must go through
// here, or whichever one happens to run last in the flush wins.
const syncPlanCount = () => {
  initialPlanCount.value =
    qmiFilter.value || qmiAppliedMobile.value
      ? filterQmiCount.value
      : availablePlans.value;
};

const mountHandler = () => {
  homeTypeList.clear();
  getHomeTypeList();
  calculateMinMaxPriceRange();
  communityHomePlans.value.sort((field1, field2) =>
    compareSortingValue(field1.plan_name, field2.plan_name)
  );
  setPlanDetailsHometypeList(
    communityHomePlans.value,
    homeTypeList,
    minRangeOnSlider.value,
    maxRangeOnSlider.value
  );

  // mounted()
  syncPlanCount();
  checkFilterConditions();

  const planId: string[] = [];
  planNameQmiList.value = [];
  communityHomePlans.value?.forEach((homePlan) => {
    planNameQmiList.value.push({
      plan_id: homePlan.plan_id,
      plan_name: homePlan.plan_name,
    });
    planId.push(homePlan.plan_id);
  });

  for (const key of Object.keys(qmiDetails.value)) {
    qmiDetails.value[key]?.forEach((qmi) => {
      if (!planId.includes(qmi.plan_code)) {
        planNameQmiList.value.push({
          plan_id: qmi.plan_code,
          plan_name: qmi.plan_market_name,
        });
        planId.push(qmi.plan_code);
      }
    });
  }
  if (!isSalesOrLandView.value) {
    urlQueryFilters();
    urlSortFilter();
  }
};

watch(divisionList, () => {
  divisionList.value = divisionList.value.sort((divisionPrev, divisionNew) =>
    divisionPrev.division_name.localeCompare(divisionNew.division_name)
  );
});

watch(communitiesList, () => {
  communitiesList.value = communitiesList.value
    ? communitiesList.value.sort((communityPrev, communityNew) =>
        communityPrev.community_name.localeCompare(communityNew.community_name)
      )
    : communitiesList.value;
});

onMounted(async () => {
  // selectDivision();
  emitter.on('divisionSelected', onDivisionSelected);
  emitter.on('communitySelected', onCommunityCodeSelected);
  window.addEventListener('click', hideDropDown);
  if (
    !communityHomePlans.value?.length &&
    !Object.keys(qmiDetails.value || {}).length
  ) {
    return;
  }
  mountHandler();
});
const selectCommunity = () => {
  if (
    communityName.value?.toLowerCase() !==
    selectedCommunity.value?.name?.toLowerCase()
  ) {
    selectedCommunity.value = communitiesList.value.find(
      (community) =>
        community.community_name.toLowerCase() ===
        communityName.value.toLowerCase()
    );
  }
};
const selectDivision = () => {
  if (
    areaName.value?.toLowerCase() !==
    selectedDivision.value?.division_name?.toLowerCase()
  ) {
    selectedDivision.value =
      divisionList.value.find((division) => {
        const area = division?.area_link_name;
        return area.toLowerCase() === areaName.value.toLowerCase();
      }) ?? ({} as DivisionInfo);
  }
};
const toTitleCase = (str) =>
  str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

watch(
  [communityHomePlans, qmiDetails],
  ([newCommunityHomePlans, newQmiDetails]) => {
    const hasQmiData = newQmiDetails && Object.keys(newQmiDetails).length > 0;
    const hasHomePlans =
      Array.isArray(newCommunityHomePlans) && newCommunityHomePlans.length > 0;

    if (hasQmiData || hasHomePlans) {
      mountHandler();
      if (isSalesOrLandView.value) {
        clearAllFilters();
      }
    }
  },
  { deep: true }
);

watch(
  selectedDivision,
  async (newVal, oldVal) => {
    if (newVal) {
      emitter.emit('newDivisonSelected', {
        area: selectedDivision.value,
      });
      // will use later

      // const path = selectedDivision.value?.pageUrl;
      // const area = path.split('/')[1];
      // if (!oldVal?.id || newVal.id !== oldVal.id) {
      //   selectedCommunity.value = {} as any;
      //   selectedNeighborhood.value = {} as any;
      //   // await getCommunities();
      //   if (newVal.id && area.toLowerCase() === areaName.value.toLowerCase())
      //     selectCommunity();
      // }
    }
  },
  {
    deep: true,
  }
);

watch(
  selectedCommunity,
  (newVal, oldVal) => {
    if (
      newVal?.community_name?.toLowerCase() !==
      oldVal?.community_name?.toLowerCase()
    ) {
      selectedNeighborhood.value = {} as any;
      planNameQmiList.value = [];
      if (oldVal && newVal.area_id) {
        emitter.emit('communityUpdated', {
          area: selectedDivision.value,
          community: selectedCommunity.value,
        });
      }
    }
  },
  {
    deep: true,
  }
);
const queryFilterExsist = (
  urlFilterData: string[],
  planHomeList: planDetails[] | Set<string>
) => {
  if (Array.isArray(planHomeList)) {
    urlFilterData = urlFilterData.filter((element) =>
      planHomeList.find((data) => data.plan_name === element)
    );
  } else {
    urlFilterData = urlFilterData.filter((element) =>
      (planHomeList as Set<string>).has(element)
    );
  }
  return urlFilterData;
};

const checkPriceInRange = (minPrice: number, maxPrice: number) => {
  if (minPrice >= maxPrice) {
    return true;
  } else if (
    !(minPrice > minRangeOnSlider.value && minPrice < maxRangeOnSlider.value) &&
    !(maxPrice > minRangeOnSlider.value && maxPrice < maxRangeOnSlider.value)
  ) {
    return true;
  }
  return false;
};

const accurateUrlPrice = (minPrice: number, maxPrice: number) => {
  if (checkPriceInRange(minPrice, maxPrice)) {
    minPrice = minRangeOnSlider.value;
    maxPrice = maxRangeOnSlider.value;
  } else if (minPrice % SliderChange || maxPrice % SliderChange) {
    minPrice = parseInt(changeMaxMinPriceRange(minPrice));
    maxPrice = minPrice + SliderChange;
  }
  return {
    minPrice,
    maxPrice,
  };
};

const checkHomeTypeApplicable = () => {
  if (homeTypeCount.value < 2) {
    updateQueryFilter(UrlFilterList.HOME_TYPE);
  }
};
const urlQueryFilters = () => {
  urlMaxPrice.value = route.query[UrlFilterList.MAX_PRICE] as string;
  urlMinPrice.value = route.query[UrlFilterList.MIN_PRICE] as string;

  const filteredHomePlans = route.query[UrlFilterList.PLAN_NAME];
  if (filteredHomePlans && Array.isArray(filteredHomePlans)) {
    listPlanName.value = queryFilterExsist(
      filteredHomePlans as string[],
      planNameQmiList.value
    );
  } else if (filteredHomePlans) {
    listPlanName.value = queryFilterExsist(
      [filteredHomePlans as string],
      planNameQmiList.value
    );
  }

  checkHomeTypeApplicable();

  const filteredHomeTypes = route.query[UrlFilterList.HOME_TYPE];
  if (filteredHomeTypes && Array.isArray(filteredHomeTypes)) {
    listHomeType.value = queryFilterExsist(
      filteredHomeTypes as string[],
      homeTypeList
    );
  } else if (filteredHomeTypes) {
    listHomeType.value = queryFilterExsist(
      [filteredHomeTypes as string],
      homeTypeList
    );
  }

  urlQmiFilter();
};

const urlPriceFilter = () => {
  let correctMinPrice = Settings.MinValue;
  let correctMaxPrice = Settings.MaxValue;

  if (urlMaxPrice.value) {
    correctMaxPrice = parseInt(urlMaxPrice.value);
  }
  if (urlMinPrice.value) {
    correctMinPrice = parseInt(urlMinPrice.value);
  }

  if (
    correctMaxPrice !== Settings.MaxValue &&
    correctMinPrice !== Settings.MinValue &&
    !conditionShowPriceRange.value &&
    !planPriceExsist.value
  ) {
    const correctMinMax = accurateUrlPrice(correctMinPrice, correctMaxPrice);
    initialMin.value = correctMinMax.minPrice;
    initialMax.value = correctMinMax.maxPrice;

    if (
      hasMobile.value &&
      (initialMin.value !== minRangeOnSlider.value ||
        initialMax.value !== maxRangeOnSlider.value)
    ) {
      applyMobilePriceFilter(initialMin.value, initialMax.value);
    }

    applyPriceFilter({
      minValue: initialMin.value,
      maxValue: initialMax.value,
    });
  } else {
    updateQueryFilter(UrlFilterList.MAX_PRICE);
    updateQueryFilter(UrlFilterList.MIN_PRICE);
  }
};
const urlSortFilter = () => {
  const sortType = route.query[UrlFilterList.SORT_BY] as string;
  const sortOption = homePlanSortOptions.find(
    (option) => option.value === sortType
  );

  if (sortOption) {
    setSorting(sortOption);
  } else {
    updateQueryFilter(UrlFilterList.SORT_BY);
  }
};

const urlQmiFilter = () => {
  const qmiList = route.query[UrlFilterList.QMI_FILTER] as string[];
  const qmiDaysFilterList = qmiList
    ? qmiDaysFilter.filter((data) => qmiList.includes(data.value))
    : [];

  if (qmiDaysFilterList.length) {
    applyUrlQmi(qmiDaysFilterList);
  } else {
    updateQueryFilter(UrlFilterList.QMI_FILTER);
  }

  if (
    hasMobile.value &&
    (listPlanName.value.length ||
      listHomeType.value.length ||
      qmiDaysFilterList.length)
  ) {
    applyMobileFilters(
      listPlanName.value,
      listHomeType.value,
      qmiDaysFilterList
    );
  }
};

const updateQueryFilter = (filterType: string) => {
  const newQuery = { ...route.query };
  newQuery[filterType] = [];

  router.push({ query: newQuery }).catch(() => {});
};

const updateQmiFilter = computed(() => {
  return `${qmiFilter.value} ${filterQmiCount.value} ${availablePlans.value} ${qmiAppliedMobile.value}`;
});

watch(updateQmiFilter, syncPlanCount);

watch(homeTypeCount, (newVal) => {
  if (newVal < 2) {
    listHomeType.value = [];
  }
});
watch([listHomeType, listPlanName], () => {
  allPlansSelected.value =
    listPlanName.value.length === planNameQmiList.value.length;

  if (!hasMobile.value) {
    applyFilter();
  }
});

// The count covers every home type, so the only reason to hide it is that there
// is nothing to show (DREESSP-1151).
const showHomeSitesCount = computed(() => availableSites.value > 0);

const conditionShowPriceRange = computed(() => {
  if (!initialHomePlanCount.value) {
    return true;
  }

  if (selectedNeighborhoodIds.value.length) {
    const currentSoldPercentage = soldPercentage.value.filter((element) =>
      selectedNeighborhoodIds.value.includes(element.neighborhoodId)
    );
    return currentSoldPercentage.length
      ? currentSoldPercentage[0].soldPercentage >= 100
      : true;
  } else {
    const currentSoldPercentage = soldPercentage.value.filter(
      (element) => element.soldPercentage < 100
    );
    return !currentSoldPercentage.length;
  }
});

// Emit Events
const filterPlanNameHomeType = (
  listHomeType: string[],
  listPlanName: string[],
  maxPrice: number,
  minPrice: number
) => {
  emit('filterPlanNameHomeType', {
    listHomeType,
    listPlanName,
    maxPrice,
    minPrice,
  });
};
const setSorting = (option: any) => {
  emit('setSorting', option);
};
const setPlanNameListId = (listPlanId: string[]) => {
  emit('setPlanNameListId', listPlanId);
};

const applyUrlQmi = (qmiFilterList: QmiDays[]) => {
  emit('applyUrlQmi', qmiFilterList);
};

const applyMobileFilters = (
  listPlanName: string[],
  listHomeType: string[],
  qmiFilterList: QmiDays[]
) => {
  emit('applyMobileFilters', { listPlanName, listHomeType, qmiFilterList });
};

const setPlanDetailsHometypeList = (
  communityHomePlans: SidebarHomePlan[],
  homeTypeList: Set<string>,
  minPrice: number,
  maxPrice: number
) => {
  emit('setPlanDetailsHometypeList', {
    communityHomePlans,
    homeTypeList,
    minPrice,
    maxPrice,
  });
};

const applyMobilePriceFilter = (minValue: number, maxValue: number) => {
  emit('applyMobilePriceFilter', { minValue, maxValue });
};
watch(selectedNeighborhoodIds, (newVal, oldVal) => {
  if (newVal !== oldVal || !selectedNeighborhood.value?.id) {
    selectedNeighborhood.value =
      neighborhoods.value.find((nb) => newVal.includes(nb.id)) || {};
    checkFilterConditions();
  }
}, {deep: true});
watch(soldPercentage, () => {
  if (!soldPercentage.value?.length) return;
  checkFilterConditions();
  urlPriceFilter();
});
const setFormatForPriceRange = computed(() => {
  const minData = minValueAfterChangeOnSlider.value + '';
  const maxData = maxValueAfterChangeOnSlider.value + '';

  const minDataToShowOnSelectorPanel = minData.substring(0, minData.length - 3);
  const maxDataToShowOnSelectorPanel = maxData.substring(0, maxData.length - 3);

  return `$${minDataToShowOnSelectorPanel}k-$${maxDataToShowOnSelectorPanel}k`;
});

const checkFilterConditions = () => {
  if (selectedNeighborhoodIds.value.length) {
    const selectedNeighborhoodId = selectedNeighborhoodIds.value[0];

    if (
      soldPercentage.value.find(
        (neighborhood) => neighborhood.neighborhoodId === selectedNeighborhoodId
      )?.totalLotsCount
    ) {
      const requiredNeighborhoodData = neighborhoodsPlanQmiCount.value.find(
        (neighborhood) => neighborhood.neighborhoodId === selectedNeighborhoodId
      );

      const planQmisCount = requiredNeighborhoodData
        ? requiredNeighborhoodData.neighborhoodPlansCount +
          requiredNeighborhoodData.neighborhoodQmisCount
        : 0;

      disableFilters.value = !planQmisCount;
    } else {
      disableFilters.value = true;
    }
  } else {
    // NOTE: kept original "!== 0" condition
    const zeroHomePlanQmiCountNeighborhood =
      neighborhoodsPlanQmiCount.value.find(
        (neighborhood) =>
          neighborhood.neighborhoodPlansCount +
            neighborhood.neighborhoodQmisCount !==
          0
      );

    disableFilters.value = !zeroHomePlanQmiCountNeighborhood;

    if (disableFilters.value) {
      const zeroLotCountNeighborhood = soldPercentage.value.find(
        (neighborhood) => neighborhood.totalLotsCount !== 0
      );
      disableFilters.value = !zeroLotCountNeighborhood;
    }
  }
};

const selectAllPlans = () => {
  listPlanId.value = [];
  listPlanName.value = [];

  if (!allPlansSelected.value) {
    planNameQmiList.value?.forEach((plan) => {
      listPlanId.value.push(plan.plan_id);
      listPlanName.value.push(plan.plan_name);
    });
  }

  allPlansSelected.value = !allPlansSelected.value;
};

const applyFilter = () => {
  filterPlanNameHomeType(
    listHomeType.value,
    listPlanName.value,
    initialMax.value,
    initialMin.value
  );
};

const hideDropDown = (e: Event) => {
  const planName = document.querySelector('.planName');
  const priceRange = document.querySelector('.priceRange');
  const homeType = document.querySelector('.homeType');
  const division = document.querySelector('.division');
  const community = document.querySelector('.community');
  const neighborhood = document.querySelector('.neighborhood');

  if (planName && !planName.contains(e.target as Node)) {
    showPlanName.value = false;
    // listPlanName.value = initialListPlanName.value
  }

  if (priceRange && !priceRange.contains(e.target as Node)) {
    showPriceRange.value = false;
  }

  if (homeType && !homeType.contains(e.target as Node)) {
    showHomeType.value = false;
    // listHomeType.value = initialHomeType.value
  }
  if (division && !division.contains(e.target as Node)) {
    showDivision.value = false;
  }
  if (community && !community.contains(e.target as Node)) {
    showCommunity.value = false;
  }
  if (neighborhood && !neighborhood.contains(e.target as Node)) {
    showNeighborhood.value = false;
  }
};
const calculateMinMaxQmiDetails = () => {
  let remainingNeighborhoodQmiMin = Settings.MaxValue;
  let remainingNeighborhoodQmiMax = Settings.MinValue;

  for (const key of Object.keys(qmiDetails.value)) {
    remainingNeighborhoodQmiMin = qmiDetails.value[key].reduce(
      (oldVal, newVal) =>
        newVal.price > 0 ? Math.min(oldVal, newVal.price) : oldVal,
      remainingNeighborhoodQmiMin
    );

    remainingNeighborhoodQmiMax = qmiDetails.value[key].reduce(
      (oldVal, newVal) => Math.max(oldVal, newVal.price),
      remainingNeighborhoodQmiMax
    );
  }

  return {
    min: remainingNeighborhoodQmiMin,
    max: remainingNeighborhoodQmiMax,
  };
};
const calculateMinMaxPriceRange = () => {
  minRangeOnSlider.value = communityHomePlans.value.reduce((oldVal, newVal) => {
    const price = newVal.price_low_with_premium;
    return price > 0 ? Math.min(oldVal, price) : oldVal;
  }, Settings.MaxValue);

  maxRangeOnSlider.value = communityHomePlans.value.reduce(
    (oldVal, newVal) => Math.max(oldVal, newVal.price_low_with_premium),
    Settings.MinValue
  );

  const qmiMinMax = calculateMinMaxQmiDetails();
  minRangeOnSlider.value = Math.min(minRangeOnSlider.value, qmiMinMax.min);
  maxRangeOnSlider.value = Math.max(maxRangeOnSlider.value, qmiMinMax.max);

  minRangeOnSlider.value = parseInt(
    changeMaxMinPriceRange(minRangeOnSlider.value)
  );
  showMinRangeOnSlider.value = minRangeOnSlider.value;

  let maxSliderValueAsPerSetup = minRangeOnSlider.value;
  while (maxSliderValueAsPerSetup < maxRangeOnSlider.value) {
    maxSliderValueAsPerSetup += SliderChange;
  }

  maxRangeOnSlider.value = maxSliderValueAsPerSetup;
  showMaxRangeOnSlider.value = maxRangeOnSlider.value;
};
const addListPlanId = (planId: string) => {
  const index = listPlanId.value.indexOf(planId);
  if (index >= 0) {
    listPlanId.value.splice(index, 1);
  } else {
    listPlanId.value.push(planId);
  }
};
const clearPriceFilter = (payload: { minShow: number; maxShow: number }) => {
  minValueAfterChangeOnSlider.value = payload.minShow;
  maxValueAfterChangeOnSlider.value = payload.maxShow;

  showMinRangeOnSlider.value = minRangeOnSlider.value;
  showMaxRangeOnSlider.value = maxRangeOnSlider.value;

  initialMax.value = Settings.MaxValue;
  initialMin.value = Settings.MinValue;

  applyFilter();
};
const clearPlanName = () => {
  // initialListPlanName.value = []
  listPlanName.value = [];
  listPlanId.value = [];

  setPlanNameListId(listPlanId.value);

  // showPlaneNameCount.value = false
  applyFilter();
};
const clearHomeType = () => {
  // showHomeTypeCount.value = false
  listHomeType.value = [];
  // initialHomeType.value = []
  applyFilter();
};
const applyPriceFilter = (payload: { minValue: number; maxValue: number }) => {
  const { minValue, maxValue } = payload;
  minValueAfterChangeOnSlider.value = minValue;
  maxValueAfterChangeOnSlider.value = maxValue;

  showMinRangeOnSlider.value = minValue;
  initialMin.value = minValue;

  showMaxRangeOnSlider.value = maxValue;
  initialMax.value = maxValue;

  applyFilter();
};

const clearAllFilters = () => {
  clearPriceFilter({ minShow: 0, maxShow: 0 });
  clearHomeType();
  clearPlanName();
};
const closePriceRange = () => {
  showPriceRange.value = false;
};

const applyPlanNameFilter = () => {
  if (listPlanName.value.length) {
    // initialListPlanName.value = listPlanName.value
    showPlanName.value = false;
    // setPlanNameListId(listPlanId.value)
    // showPlaneNameCount.value = true
    // applyFilter()
  }
};
const applyHomeTypeFilter = () => {
  if (listHomeType.value.length) {
    // initialHomeType.value = listHomeType.value
    // showHomeTypeCount.value = true
    showHomeType.value = false;
    // applyFilter()
  }
};
const changeMaxMinPriceRange = (minValue: number) => {
  const stringMinMaxValue = minValue + '';
  let changedMinRangeSliderAsPerStep: string;

  if (stringMinMaxValue.length <= 6) {
    +stringMinMaxValue.substring(1, 2) >= 5
      ? (changedMinRangeSliderAsPerStep =
          stringMinMaxValue.substring(0, 1) +
          '5' +
          '0'.repeat((minRangeOnSlider.value + '').length - 2))
      : (changedMinRangeSliderAsPerStep =
          stringMinMaxValue.substring(0, 1) +
          '0'.repeat(stringMinMaxValue.length - 1));
  } else {
    +stringMinMaxValue.substring(2, 3) >= 5
      ? (changedMinRangeSliderAsPerStep =
          stringMinMaxValue.substring(0, 2) +
          '5' +
          '0'.repeat(stringMinMaxValue.length - 3))
      : (changedMinRangeSliderAsPerStep =
          stringMinMaxValue.substring(0, 2) +
          '0'.repeat(stringMinMaxValue.length - 2));
  }

  return changedMinRangeSliderAsPerStep;
};

const sortHomeTypeList = () => {
  const sortedHomeTypeArray: string[] = [];
  for (const type of OrderHomeTypeList) {
    if (homeTypeList.has(type)) {
      sortedHomeTypeArray.push(type);
    }
  }
  homeTypeList.clear();
  for (const type of sortedHomeTypeArray) {
    homeTypeList.add(type);
  }
};


const getHomeTypeList = () => {
  communityHomePlans.value?.forEach((homePlan) => {
    homeTypeList.add(homePlan.plan_type);
  });

  Object.keys(qmiDetails.value)?.forEach((key) => {
    qmiDetails.value[key]?.forEach((eachQmi) => {
      homeTypeList.add(eachQmi.plan_type);
    });
  });

  sortHomeTypeList();
};
__expose({
  clearAllFilters,
});

const onDivisionSelected = (division: DivisionInfo) => {
  if(selectedDivision.value.division_code !== division.division_code) {
    selectedDivision.value = division;
    selectedCommunity.value = {} as CommunityInfo;
    selectedNeighborhood.value = {} as any;
  }
  showDivision.value = false;
};

const onCommunityCodeSelected = (community: string) => {
  const selectedCommunity = communitiesList.value.find((comm) => comm.community_code === community);
  if (selectedCommunity) {
    onCommunitySelected(selectedCommunity);
  }
};

const onCommunitySelected = (community: CommunityInfo) => {
  if(selectedCommunity.value.community_code !== community.community_code) {
    selectedCommunity.value = community;
  }
  showCommunity.value = false;
};
const onNeighborhoodSelected = (nb: any) => {
  if(selectedNeighborhood.value.id !== nb.id) {
    selectedNeighborhood.value = nb;
    emit('selectNeighborhood', nb.id);
  }
  showNeighborhood.value = false;
};

const togglePriceRangeDropdown = () => {
  conditionShowPriceRange.value || disableFilters.value
    ? (showPriceRange.value = false)
    : (showPriceRange.value = !showPriceRange.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, [
      (_unref(headerData).community_name)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(headerData).community_name), 1))
        : _createCommentVNode("", true),
      (!_unref(isSalesOrLandView))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Discover the perfect site for your new home."))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (
          ((selectedDivision.value.area_code && selectedCommunity.value.community_code) ||
            !_unref(isSalesOrLandView)) &&
          initialPlanCount.value
        )
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(initialPlanCount.value) + " new home plans", 1))
        : _createCommentVNode("", true),
      (showHomeSitesCount.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(availableSites)) + " opportunities available", 1))
        : _createCommentVNode("", true)
    ]),
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "community-details-info" }, [
      _createElementVNode("i", { class: "green-circle" }),
      _createElementVNode("span", null, "Tap a photo to see sites on map")
    ], -1)),
    _createElementVNode("div", _hoisted_7, [
      (_unref(isSalesOrLandView))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            "aria-label": "division",
            class: "division",
            onClick: hideDropDown
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "input-label" }, "Division", -1)),
            _createElementVNode("button", {
              class: "community-details-btn flexDiv",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showDivision.value = !showDivision.value))
            }, [
              (selectedDivision.value?.division_name)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "title-case-text",
                    title: toTitleCase(selectedDivision.value.division_name)
                  }, _toDisplayString(selectedDivision.value.division_name.toLowerCase()), 9, _hoisted_8))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, "Division")),
              _createVNode(ArrowDownIcon, {
                class: _normalizeClass({ 'rotate-180': showDivision.value })
              }, null, 8, ["class"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(['dropdown scrollbar', { show: showDivision.value }])
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "homeType-title" }, "Division", -1)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(divisionList), (division) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "dropdown-item",
                    key: division.division_code,
                    onClick: ($event: any) => (onDivisionSelected(division))
                  }, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(division.division_name.toLowerCase()), 1)
                  ], 8, _hoisted_10))
                }), 128))
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_unref(isSalesOrLandView))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            "aria-label": "community",
            class: "community",
            onClick: hideDropDown
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "input-label" }, "Community", -1)),
            _createElementVNode("button", {
              disabled: !selectedDivision.value.area_code,
              class: "community-details-btn flexDiv",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showCommunity.value = !showCommunity.value))
            }, [
              (selectedCommunity.value?.community_name)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "title-case-text",
                    title: toTitleCase(selectedCommunity.value.community_name)
                  }, _toDisplayString(selectedCommunity.value.community_name.toLowerCase()), 9, _hoisted_13))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, "Community")),
              _createVNode(ArrowDownIcon, {
                class: _normalizeClass({ 'rotate-180': showCommunity.value })
              }, null, 8, ["class"])
            ], 8, _hoisted_12),
            _createElementVNode("div", {
              class: _normalizeClass(['dropdown scrollbar', { show: showCommunity.value }])
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "homeType-title" }, "Community", -1)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communitiesList), (community) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "dropdown-item",
                    key: community.community_code,
                    onClick: ($event: any) => (onCommunitySelected(community))
                  }, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(community.community_name.toLowerCase()), 1)
                  ], 8, _hoisted_15))
                }), 128))
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_unref(isSalesOrLandView))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            "aria-label": "neighborhood",
            class: "neighborhood",
            onClick: hideDropDown
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "input-label" }, "Neighborhood", -1)),
            _createElementVNode("button", {
              disabled: 
            !selectedDivision.value.area_code || !selectedCommunity.value.community_code
          ,
              class: "community-details-btn flexDiv",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showNeighborhood.value = !showNeighborhood.value))
            }, [
              (
              selectedNeighborhood.value && selectedNeighborhood.value.neighborhood_name
            )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "title-case-text",
                    title: toTitleCase(selectedNeighborhood.value.neighborhood_name)
                  }, _toDisplayString(selectedNeighborhood.value.neighborhood_name), 9, _hoisted_18))
                : (_openBlock(), _createElementBlock("span", _hoisted_19, "Neighborhood")),
              _createVNode(ArrowDownIcon, {
                class: _normalizeClass({ 'rotate-180': showNeighborhood.value })
              }, null, 8, ["class"])
            ], 8, _hoisted_17),
            _createElementVNode("div", {
              class: _normalizeClass(['dropdown scrollbar', { show: showNeighborhood.value }])
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "homeType-title" }, "Neighborhood", -1)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(neighborhoods.value, (nb) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass([
                'dropdown-item',
                {
                  'disabled-item':
                    !_unref(neighborhoodLotsCount)(nb.id) ||
                    _unref(neighborhoodLotsCount)(nb.id) <= 0,
                },
              ]),
                    key: nb.id,
                    onClick: ($event: any) => (onNeighborhoodSelected(nb))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                  'form-check',
                  {
                    'is-selected':
                      _unref(selectedNeighborhoodIds).includes(nb.id) &&
                      !(
                        !_unref(neighborhoodLotsCount)(nb.id) ||
                        _unref(neighborhoodLotsCount)(nb.id) <= 0
                      ),
                  },
                  { 'coming-soon': _unref(isComingSoon)(nb) },
                ])
                    }, _toDisplayString(nb.neighborhood_name), 3)
                  ], 10, _hoisted_20))
                }), 128))
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        "aria-label": "price range",
        class: "priceRange",
        onClick: hideDropDown
      }, [
        (_unref(isSalesOrLandView))
          ? (_openBlock(), _createElementBlock("label", _hoisted_21, "Price Range"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass([
            { disablePriceRange: conditionShowPriceRange.value || _unref(planPriceExsist) },
            'community-details-btn',
            { disableFilter: disableFilters.value },
          ]),
          onClick: togglePriceRangeDropdown
        }, [
          (!minValueAfterChangeOnSlider.value && !maxValueAfterChangeOnSlider.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Price Range"))
            : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(conditionShowPriceRange.value || !_unref(initialHomePlanCount) || _unref(planPriceExsist)
              ? 'Price Range'
              : setFormatForPriceRange.value), 1)),
          (!conditionShowPriceRange.value)
            ? (_openBlock(), _createBlock(ArrowDownIcon, {
                key: 2,
                class: _normalizeClass({ 'rotate-180': showPriceRange.value })
              }, null, 8, ["class"]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(['dropdown', { show: showPriceRange.value }])
        }, [
          (showPriceRange.value)
            ? (_openBlock(), _createBlock(RangeSlider, {
                key: 0,
                min: minRangeOnSlider.value,
                max: maxRangeOnSlider.value,
                showMinRangeOnSlider: showMinRangeOnSlider.value,
                showMaxRangeOnSlider: showMaxRangeOnSlider.value,
                onApplyPriceFilter: applyPriceFilter,
                onClearPriceFilter: clearPriceFilter,
                onClosePriceRange: closePriceRange
              }, null, 8, ["min", "max", "showMinRangeOnSlider", "showMaxRangeOnSlider"]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", {
        "aria-label": "plan name",
        class: "planName relative",
        onClick: hideDropDown
      }, [
        (_unref(isSalesOrLandView))
          ? (_openBlock(), _createElementBlock("label", _hoisted_24, "Plan Name"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["community-details-btn flexDiv", [{ disableFilter: disableFilters.value || !_unref(initialHomePlanCount) }]]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (!disableFilters.value ? (showPlanName.value = !showPlanName.value) : ''))
        }, [
          _cache[14] || (_cache[14] = _createElementVNode("span", null, "Plan Name", -1)),
          (listPlanName.value?.length > 0 && _unref(initialHomePlanCount))
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "(" + _toDisplayString(listPlanName.value.length) + ")", 1))
            : _createCommentVNode("", true),
          _createVNode(ArrowDownIcon, {
            class: _normalizeClass({ 'rotate-180': showPlanName.value })
          }, null, 8, ["class"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(['dropdown scrollbar', { show: showPlanName.value }])
        }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "all",
                  class: "form-check-input",
                  value: allPlansSelected.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((allPlansSelected).value = $event)),
                  onClick: selectAllPlans
                }, null, 8, _hoisted_28), [
                  [_vModelCheckbox, allPlansSelected.value]
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("label", {
                  for: "all",
                  class: "form-check-label"
                }, "Select All", -1))
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planNameQmiList.value, (planName) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "dropdown-item",
                key: planName.plan_id
              }, [
                _createElementVNode("div", {
                  for: planName.plan_id,
                  class: "form-check"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((listPlanName).value = $event)),
                    value: planName.plan_name,
                    id: planName.plan_id,
                    onClick: ($event: any) => (addListPlanId(planName.plan_id))
                  }, null, 8, _hoisted_30), [
                    [_vModelCheckbox, listPlanName.value]
                  ]),
                  _createElementVNode("label", {
                    for: planName.plan_id,
                    class: "form-check-label"
                  }, _toDisplayString(planName.plan_name), 9, _hoisted_31)
                ], 8, _hoisted_29)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              class: "cta__btntext",
              onClick: clearPlanName
            }, "Clear"),
            _createElementVNode("button", {
              class: _normalizeClass([
                'cta__btnsolid',
                { disableApplyButton: !listPlanName.value?.length },
              ]),
              onClick: applyPlanNameFilter
            }, " Apply ", 2)
          ])
        ], 2)
      ]),
      _createElementVNode("div", {
        "aria-label": "home type",
        class: "homeType",
        onClick: hideDropDown
      }, [
        (_unref(isSalesOrLandView))
          ? (_openBlock(), _createElementBlock("label", _hoisted_33, "Home Type"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["community-details-btn flexDiv", [
            {
              disableFilter:
                disableFilters.value || !_unref(initialHomePlanCount) || _unref(homeTypeCount) < 2,
            },
          ]]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (!disableFilters.value ? (showHomeType.value = !showHomeType.value) : ''))
        }, [
          _cache[16] || (_cache[16] = _createElementVNode("span", null, "Home Type", -1)),
          (listHomeType.value?.length > 0 && _unref(initialHomePlanCount))
            ? (_openBlock(), _createElementBlock("span", _hoisted_34, "(" + _toDisplayString(listHomeType.value.length) + ")", 1))
            : _createCommentVNode("", true),
          _createVNode(ArrowDownIcon, {
            class: _normalizeClass({ 'rotate-180': showHomeType.value })
          }, null, 8, ["class"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(['dropdown scrollbar', { show: showHomeType.value }])
        }, [
          _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "homeType-title" }, "Home Type", -1)),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeTypeList, (homeType, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "dropdown-item",
                key: index
              }, [
                _createElementVNode("div", {
                  for: index,
                  class: "form-check"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((listHomeType).value = $event)),
                    value: homeType,
                    id: index
                  }, null, 8, _hoisted_36), [
                    [_vModelCheckbox, listHomeType.value]
                  ]),
                  _createElementVNode("label", {
                    for: index,
                    class: "form-check-label"
                  }, _toDisplayString(homeType), 9, _hoisted_37)
                ], 8, _hoisted_35)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              class: "cta__btntext",
              onClick: clearHomeType
            }, "Clear"),
            _createElementVNode("button", {
              class: _normalizeClass([
                'cta__btnsolid',
                { disableApplyButton: !listHomeType.value.length },
              ]),
              onClick: applyHomeTypeFilter
            }, " Apply ", 2)
          ])
        ], 2)
      ])
    ])
  ]))
}
}

})